<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<!-- header start -->

<!-- Stripe Snackbar -->
<roma-shared-stripe-snackbar></roma-shared-stripe-snackbar>

<!-- Trial Disclaimer -->
<roma-pro-disclaimer-banner
  *ngIf="isLowerThan1450px && !userIdByParameter"
  (emitRefresh)="refresh()"
  [rootModule]="'timetracking2'"
></roma-pro-disclaimer-banner>

<roma-back-button
  *ngIf="isFromTeamView"
  (backClicked)="goBack()"
></roma-back-button>
<div class="container-page-header" *ngIf="!userIdByParameter">
  <h1 class="page-title">
    <ng-container *ngIf="!isAdminAbsences">
      {{ userAbsenceTitle }}
      <div class="tooltip-container">
        <img
          width="32px"
          class="help-icon"
          [src]="iconDialog"
          (click)="showDialog()"
        />
        <div
          *ngIf="showToolTip"
          class="title-tooltip-wrapper"
          (click)="toggleTooltip(false)"
        ></div>
        <div
          class="help-tooltip 22"
          *ngIf="showToolTip"
          romaRomaToolTip
          [showToolTip]="showToolTip"
          (clicked)="toggleTooltip($event)"
        >
          <div [innerHTML]="'clockAbsence.tooltip' | translate"></div>
          <a *ngIf="academyLink?.length" [href]="academyLink" target="_blank">{{
            'clockAbsence.tooltipUrl' | translate
          }}</a>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isAdminAbsences">
      {{
        (resize$ | async)?.payload?.mobile
          ? ('clockHour.absences' | translate)
          : ('clockHourAdmin.title' | translate)
      }}
      <div class="tooltip-container">
        <img
          width="32px"
          class="help-icon"
          [src]="iconDialog"
          (click)="showDialog()"
        />
        <div
          *ngIf="showToolTip"
          class="title-tooltip-wrapper"
          (click)="toggleTooltip(false)"
        ></div>
        <div
          class="help-tooltip 22"
          *ngIf="showToolTip"
          romaRomaToolTip
          [showToolTip]="showToolTip"
          (clicked)="toggleTooltip($event)"
        >
          <div [innerHTML]="'adminClockAbsence.tooltip' | translate"></div>
          <a *ngIf="academyLink?.length" [href]="academyLink" target="_blank">{{
            'adminClockAbsence.tooltipUrl' | translate
          }}</a>
        </div>
      </div>
    </ng-container>

    <mat-icon
      *ngIf="
        isAdminAbsences &&
        viewTypeActive === absenceViews?.CALENDAR &&
        (resize$ | async)?.payload?.mobile
      "
      class="material-icons mr-1 float-end"
      (click)="openMobileTeamActions = true"
    >
      more_vert
    </mat-icon>
  </h1>
  <div class="container-options">
    <!-- Videotutorial button -->
    <button
      *ngIf="getLang() === 'es' && !(resize$ | async)?.payload?.mobile"
      class="tutorial btn-margins"
      (click)="openVideo(abscenseType)"
    >
      <strong>{{ 'tutorial.tutorial' | translate }}</strong>
      <img class="video" src="assets/icons/gl_play-tutorial.svg" />
    </button>
    <!-- Videotutorial button -->

    <!-- download button -->
    <roma-shared-download-btn
      *ngIf="
        resultSearch?.docs &&
        !(resize$ | async)?.payload?.mobile &&
        isAdminAbsences
      "
      [featureExcel]="featureRef.ClockHour.DownloadExcel"
      [showDownloadExcel]="true"
      [showDownloadPdf]="false"
      (download)="download($event)"
      style="margin-right: 12px"
    ></roma-shared-download-btn>

    <button
      romaProFeature
      [featureUserHide]="{
        type: 'some',
        features: [
          featureUserRef.CompanyAdjust.update,
          featureUserRef.ClockHourAbsenceCompany.approve
        ]
      }"
      class="btn-download btn-holiday"
      *ngIf="!(resize$ | async)?.payload?.mobile"
      (click)="navigateToHolidaysSettings(abscenseType)"
    >
      <mat-icon class="holiday-icon" svgIcon="celebration_icon"> </mat-icon>

      {{ 'clockAbsence.goToHolidays' | translate }}
    </button>

    <button
      *ngIf="!(resize$ | async)?.payload?.mobile"
      class="roma-button mobile-small"
      romaProFeature
      [featureUser]="featureUserRef.ClockHourAbsence.create"
      (clicked)="launchModalAbsence()"
    >
      <img
        *ngIf="!(hasAddClockAbsenceFeature$ | async)"
        class="icon-star-pro-feature"
        src="assets/icons/star.svg"
      />
      <ng-container *ngIf="!(resize$ | async)?.payload?.mobile">
        {{ 'clockAbsence.addAbsence' | translate }}
      </ng-container>
      <img class="icon-option" src="assets/icons/plus.svg" />
    </button>
  </div>
</div>

<div class="page-options row align-items-start" *ngIf="!isAdminAbsences">
  <div class="col-8 options p-0">
    <div class="d-inline-flex">
      <div
        class="absence-calendar-toolbar {{ isFromTeamView && 'border-left-0' }}"
        *ngIf="viewTypeActive === absenceViews?.CALENDAR"
      >
        <button (click)="goToPrevYear()" class="go_back">
          <mat-icon class="material-icons"> chevron_left </mat-icon>
        </button>
        <button (click)="goToCurrentYear()" class="go_today">
          {{ calendarYear }}
        </button>
        <button (click)="goToNextYear()" class="go_next">
          <mat-icon class="material-icons"> chevron_right </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="col-4 text-right p-0">
    <roma-shared-download-btn
      *ngIf="
        resultSearch?.docs &&
        !(resize$ | async)?.payload?.mobile &&
        !userIdByParameter
      "
      [featureExcel]="featureRef.ClockHour.DownloadExcel"
      [showDownloadExcel]="true"
      [showDownloadPdf]="false"
      (download)="download($event)"
    ></roma-shared-download-btn>

    <button
      *ngIf="!(resize$ | async)?.payload?.mobile && userIdByParameter"
      class="roma-button mobile-small button-add"
      romaProFeature
      [featureUser]="featureUserRef.ClockHourAbsence.create"
      (clicked)="launchModalAbsence()"
    >
      {{ 'clockAbsence.addAbsence' | translate }}
      <img class="icon-option" src="assets/icons/plus.svg" />
    </button>
  </div>
</div>

<div class="page-options row align-items-start" *ngIf="isAdminAbsences">
  <div class="col-7 col-md-12 p-0">
    <div class="d-md-inline-flex">
      <div>
        <div class="filter-wrapper mobile-hidden">
          <button
            class="btn btn-align"
            (click)="changeViewToCalendar()"
            [ngClass]="{ active: viewTypeActive === absenceViews?.CALENDAR }"
          >
            <mat-icon
              class="align-icon"
              svgIcon="user_icon"
              *ngIf="isAdminAbsences"
            ></mat-icon>

            <span class="align-text">
              {{ 'clockHour.viewTeam' | translate }}
            </span>
          </button>
        </div>
      </div>

      <div *ngIf="(resize$ | async)?.payload?.mobile">
        <button
          class="d-inline-block d-flex align-items-center mobile-view-selector gap-1"
          (click)="openMobileViewType = true"
        >
          <ng-container *ngIf="viewTypeActive === absenceViews?.CALENDAR">
            <mat-icon class="material-icons mr-1"> person </mat-icon>
            <span class="icon-text">
              {{
                isAdminAbsences
                  ? ('clockHour.viewTeam' | translate)
                  : ('dashboard.calendar' | translate)
              }}
            </span>
          </ng-container>
          <mat-icon class="material-icons arrow ml-1"> expand_more </mat-icon>
        </button>
      </div>

      <div
        class="absence-calendar-toolbar is-admin-absences"
        *ngIf="
          viewTypeActive === absenceViews?.CALENDAR &&
          !(resize$ | async)?.payload?.mobile
        "
      >
        <roma-monthly-weekly-filter
          (changePeriodRange)="changePeriodTeamView($event)"
          [defaultValues]="defaultValues"
          [showPeriodSwitch]="false"
          [dateFormat]="(resize$ | async)?.payload?.mobile ? 'short' : 'long'"
          [clickOnCurrentPeriod]="true"
        ></roma-monthly-weekly-filter>

        <roma-rm-filter-button
          [source]="sourceUserFilter"
          (changes)="rmFilterCalendarChanges($event)"
          [title]="'general.filters' | translate"
          [matIcon]="'keyboard_arrow_down'"
        ></roma-rm-filter-button>
      </div>
    </div>
  </div>
  <div
    class="col-5 text-right"
    *ngIf="
      (resize$ | async)?.payload?.mobile &&
      viewTypeActive === absenceViews?.CALENDAR
    "
  >
    <roma-rm-filter-button
      [source]="sourceMobileFilter"
      (changes)="rmFilterCoreChanges($event)"
      [title]="'general.filters' | translate"
      [matIcon]="'keyboard_arrow_down'"
    ></roma-rm-filter-button>
  </div>
</div>

<div
  class="monthly-weekly-filter-mobile"
  *ngIf="
    isAdminAbsences &&
    (resize$ | async)?.payload?.mobile &&
    viewTypeActive === absenceViews?.CALENDAR
  "
>
  <roma-monthly-weekly-filter
    (changePeriodRange)="changePeriodTeamView($event)"
    [defaultValues]="defaultValues"
    [showPeriodSwitch]="false"
    [dateFormat]="(resize$ | async)?.payload?.mobile ? 'short' : 'long'"
    [clickOnCurrentPeriod]="true"
  ></roma-monthly-weekly-filter>
</div>

<div *ngIf="openMobileViewType" class="mobile-viewtype-wrapper">
  <div class="viewtype-list">
    <h4>{{ 'general.view' | translate }}</h4>
    <div class="link-list">
      <div
        class="list-item"
        (click)="changeViewToCalendar(); openMobileViewType = false"
      >
        <span class="icon-text">
          {{
            isAdminAbsences
              ? ('clockHour.viewTeam' | translate)
              : ('dashboard.calendar' | translate)
          }}
        </span>
        <img
          *ngIf="viewTypeActive === absenceViews?.CALENDAR"
          class="prev-icon"
          src="/assets/icons/ic_check.svg"
        />
      </div>
      <div
        class="list-item"
        (click)="changeViewToList(); openMobileViewType = false"
      >
        <span class="icon-text">
          {{
            isAdminAbsences
              ? ('adminClockAbsence.viewAll' | translate)
              : ('dashboard.list' | translate)
          }}
        </span>
      </div>
      <div class="text-center close-btn-wrapper">
        <img
          (click)="openMobileViewType = false"
          class="close-btn"
          src="/assets/icons/btn_close.svg"
          alt="close"
        />
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="openMobileTeamActions && isAdminAbsences"
  class="mobile-viewtype-wrapper mobile-actions"
>
  <div class="viewtype-list">
    <h4>{{ 'general.actions' | translate }}</h4>
    <div class="link-list">
      <div
        *ngIf="getLang() === 'es'"
        class="list-item"
        (click)="openVideo(abscenseType); openMobileTeamActions = false"
      >
        <span class="icon-text">
          {{ 'tutorial.tutorial' | translate }}
        </span>
        <mat-icon class="material-icons mr-1 prev-icon"> play_circle </mat-icon>
      </div>
      <div
        class="list-item"
        (click)="showCreateUser(); openMobileTeamActions = false"
      >
        <span class="icon-text">
          {{ 'general.addUserBtn' | translate }}
        </span>
        <mat-icon class="material-icons mr-1 prev-icon"> person_add </mat-icon>
      </div>
      <div
        romaProFeature
        [featureUserHide]="{
          type: 'some',
          features: [
            featureUserRef.CompanyAdjust.update,
            featureUserRef.ClockHourAbsenceCompany.approve
          ]
        }"
        class="list-item"
        (click)="navigateToHolidaysSettings(abscenseType)"
      >
        <span class="icon-text">
          {{ 'clockAbsence.goToHolidays_mobile' | translate }}
        </span>
        <mat-icon class="material-icons mr-1 prev-icon"> celebration </mat-icon>
      </div>
      <div
        class="list-item"
        (click)="download('excel'); openMobileTeamActions = false"
      >
        <span class="icon-text">
          {{ 'general.downloadExcel' | translate }}
        </span>
        <mat-icon class="material-icons mr-1 prev-icon">
          download_alt
        </mat-icon>
      </div>
      <div class="text-center close-btn-wrapper">
        <img
          (click)="openMobileTeamActions = false"
          class="close-btn"
          src="/assets/icons/btn_close.svg"
          alt="close"
        />
      </div>
    </div>
  </div>
</div>

<!-- header end -->

<ng-container
  *ngIf="
    viewTypeActive === absenceViews?.CALENDAR &&
    resultSearch?.docs &&
    !isAdminAbsences
  "
>
  <div class="row calendar-container full-height gx-md-5">
    <div class="col-md-12 col-lg-5 col-xl-3 scrollable-column">
      <div [ngClass]="{ 'mb-3 mb-md-0': isAdmin }">
        <roma-absence-counter
          [vacationReport]="vacationReport"
        ></roma-absence-counter>
      </div>
      <roma-absence-summary
        [absenceItems]="pendingEvents"
        [title]="'clockAbsence.pendingAbsences' | translate"
        [loadingTotal]="loadingTotal"
        *ngIf="!isAdmin || isFromTeamView"
      ></roma-absence-summary>
      <roma-absence-summary-counter
        *ngIf="!(resize$ | async)?.payload?.mobile"
        [absenceCounts]="totalSummary"
        [loadingTotal]="loadingTotal"
        [title]="'clockAbsence.validatedAbsences' | translate"
      ></roma-absence-summary-counter>
    </div>
    <div class="col-md-12 col-lg-7 col-xl-9 pb-5">
      <roma-mf-calendar
        [calendarEvents]="calendarEvents"
        [onEventClick]="showAbsenceDetailFromCalendar"
        [onDayClick]="launchModalAbsence"
        [year]="calendarYear"
      ></roma-mf-calendar>
      <roma-absence-summary-counter
        *ngIf="(resize$ | async)?.payload?.mobile"
        [absenceCounts]="totalSummary"
        [loadingTotal]="loadingTotal"
        [title]="'clockAbsence.validatedAbsences' | translate"
      ></roma-absence-summary-counter>
    </div>
  </div>
</ng-container>

<ng-container
  *ngIf="viewTypeActive === absenceViews?.CALENDAR && isAdminAbsences"
>
  <div class="row">
    <div class="col employee-calendar-table">
      <roma-mf-employee-calendar
        [absencesEmployees]="filteredAbsencesEmployees"
        [filterDate]="filterDate"
        [onEventClick]="showAbsenceDetailFromEmployeeCalendar"
        [onCreateUser]="showCreateUser"
        [onUserDetails]="showUserDetail"
        [onCreateAbsence]="createAbsenceFromEmployeeCalendar"
      ></roma-mf-employee-calendar>
    </div>
  </div>
</ng-container>

<button
  class="mobile-button-add"
  (click)="launchModalAbsence()"
  *ngIf="(resize$ | async)?.payload?.mobile"
>
  <img
    src="/assets/icons/gl_plus-1.svg"
    alt="{{ 'deals.createDeals' | translate }}"
  />
</button>
